import * as React from 'react';

import { Group, Panel, Separator } from 'react-resizable-panels';

import { cn } from '@/lib/utils';

import GripDotVerticalIcon from '../icons/grip-dot-vertical';

function ResizablePanelGroup({ className, ...props }: React.ComponentProps<typeof Group>) {
  return <Group data-slot="resizable-panel-group" className={cn('flex h-full w-full data-[orientation=vertical]:flex-col', className)} {...props} />;
}

function ResizablePanel({ ...props }: React.ComponentProps<typeof Panel>) {
  return <Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof Separator> & {
  withHandle?: boolean;
}) {
  return (
    <Separator
      data-slot="resizable-handle"
      className={cn(
        "bg-grey-2 [&[data-separator='active']]:bg-default-blue [&[data-separator='hover']]:bg-grey-3 relative flex w-0.5 items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-none data-[orientation=vertical]:h-0.5 data-[orientation=vertical]:w-full data-[orientation=vertical]:after:left-0 data-[orientation=vertical]:after:h-1 data-[orientation=vertical]:after:w-full data-[orientation=vertical]:after:translate-x-0 data-[orientation=vertical]:after:-translate-y-1/2 [&[data-orientation=vertical]>div]:rotate-90 [&[data-separator='active']]:w-[3px]",
        className,
      )}
      {...props}>
      {withHandle && (
        <div className="bg-grey-2 z-10 flex h-4 w-3 items-center justify-center rounded border">
          <GripDotVerticalIcon className="size-2.5" />
        </div>
      )}
    </Separator>
  );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
